import { render } from "./Overview.vue?vue&type=template&id=4d4b8f44"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=4d4b8f44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d4b8f44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d4b8f44', __exports__)) {
    api.reload('4d4b8f44', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=4d4b8f44", () => {
    api.rerender('4d4b8f44', render)
  })

}


export default __exports__